// extracted by mini-css-extract-plugin
export var grid = "WorkBlock-module--grid--326Yj";
export var imageText = "WorkBlock-module--imageText--mrk19";
export var overlay = "WorkBlock-module--overlay--VFxSP";
export var carouselText = "WorkBlock-module--carouselText--2vm8Q";